import { render, staticRenderFns } from "./jumpList.vue?vue&type=template&id=045bd4c5"
import script from "./jumpList.vue?vue&type=script&lang=js"
export * from "./jumpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports